module.exports = __webpack_public_path__ + "static/familyinneed-233fd18a38b21be1107ffb51f81e1933.jpg";